// extracted by mini-css-extract-plugin
export default {"root":"ProgressIndicator_root__sbu4Y"};